import Vue from 'vue';
import axios from 'axios';
import VueAxios from 'vue-axios';
import qs from 'qs';
import store from '@/store';
import { isPlainObject } from '@/utils';
import i18nZh from '@/locales/zh-CN.json';
import i18nEn from '@/locales/en.json';
import AJAXFILTER from '@/assets/json/filter.json';

const AJAXCODE = {
  en: i18nEn.ajax,
  'zh-CN': i18nZh.ajax,
};

Vue.use(VueAxios, axios);
// axios.defaults.baseURL = process.env.BASE_URL;
axios.defaults.headers['X-Requested-With'] = 'XMLHttpRequest';
axios.defaults.headers.platformType = 1;
// axios.defaults.baseURL = 'http://dev-aq.caocaokeji.cn/uc-password'; // 开发环境
// axios.defaults.baseURL = 'https://uc-api.caocaoglobal.com/uc-password'; // 生成环境

axios.interceptors.request.use((config) => {
  let { data } = config;

  if (isPlainObject(data)) {
    // 复制以避免修改源对象
    data = { ...data };

    // 将数组转化为字符串，否则后端无法识别
    Object.keys(data).forEach((key) => {
      const value = data[key];

      if (Array.isArray(value)) {
        data[key] = value.join();
      }
    });

    // 将对象转化为字符串，否则后端无法识别
    config.data = qs.stringify(data);
  }

  const getPwd = (url, name) => {
    const reg = new RegExp(`(^|&)${name}=([^&]*)(&|$)`);
    const r = url.substr(0).match(reg);
    return r;
  };
  const { secret } = store.state.appCloudLayoutStore;
  if (config.data && config.data.indexOf('password') > -1 && typeof secret === 'function') {
    // formData形式  password 加密
    const pwd = decodeURIComponent(getPwd(config.data, 'password')[2]);
    const newPwd = encodeURIComponent(secret(pwd));
    config.data = config.data.replace(`password=${getPwd(config.data, 'password')[2]}`, `password=${newPwd}`);
  }

  if (config.url && (config.url.indexOf('?') > -1 && config.url.substr(config.url.indexOf('?') + 1).indexOf('password') > -1) && typeof secret === 'function') {
    // url 拼接形式
    const str = config.url.substr(config.url.indexOf('?') + 1);
    const pwd = decodeURIComponent(getPwd(str, 'password')[2]);
    const newPwd = encodeURIComponent(secret(pwd));
    config.url = config.url.replace(`password=${getPwd(str, 'password')[2]}`, `password=${newPwd}`);
  }

  return config;
});
axios.interceptors.response.use((response) => {
  const { data = {}, status, statusText } = response;
  let message;
  // session过期跳转到警告页面
  if (data.code === 'com.geely.account.SessionIsEmpty') {
    window.location.href = '/#/statePage/warning';
    if (!!window.ActiveXObject || 'ActiveXObject' in window) {
      // IE浏览器特殊处理
      window.location.reload();
    }
    // return data;
    throw new Error(data);
  }

  if (data.code) {
    // Create an unified error code in constant case.
    // For example: unknown-error => UNKNOWN_ERROR
    data.CODE = data.code
      .replace(/([a-z])([A-Z])/g, '$1_$2')
      .replace(/\W+/g, '_')
      .toUpperCase();
  }

  if (status >= 200 && status < 300) {
    if (data.code !== 'success') {
      ({ message } = data);
    }
  } else {
    message = data.message || statusText;
  }

  if (message) {
    const error = new Error(message);

    error.code = data.code;
    error.CODE = data.CODE;
    error.data = data.data;
    error.res = response;
    error.response = response;
    const lang = store.state.language;
    if (!AJAXCODE[lang][error.CODE]) {
      Vue.prototype.$message.error(AJAXCODE[lang].notFount);
    } else if (!AJAXFILTER[error.CODE]) {
      // 异步校验密码不需要message
      Vue.prototype.$message.error(AJAXCODE[lang][error.CODE]);
    }
    throw error;
  }

  return data;
});

export default axios;
